import { InteractiveObject } from "../../../core/object/interactive-object.js";
import { getMedical } from "../medical.js";
/**
 * Represents interactive text label.
 */
export class InteractiveText extends InteractiveObject {
    /** Empty constructor. */
    constructor(theViewer, theObjId = "") {
        super(theViewer, theObjId);
        this._myModule = getMedical(theViewer);
        this._myController = this._myModule.interactiveText();
        if (this._myObjId === "") {
            this._myObjId = "_InteractiveText";
        }
        this._myController.createTextLabel(this._myObjId);
        this._myViewer.interactiveContext.displayObjectList(`${this._myObjId}`, false);
    }
    /** Make a copy of existing object with new id */
    clone() { return new InteractiveText(this._myViewer, super._clone()); }
    /** Return text. */
    get text() {
        return this._myController != null ? this._myController.getTextLabelText(this._myObjId) : "";
    }
    /** Set text. */
    set text(theText) { this._myController.setTextLabelText(this._myObjId, theText); }
    /** Return text wrapping length, or -1 if no wrapping is required. */
    get textWrapping() {
        return this._myController != null ? this._myController.getTextLabelWrapping(this._myObjId)
            : -1.0;
    }
    /** Set text wrapping length. */
    set textWrapping(theLength) {
        this._myController.setTextLabelWrapping(this._myObjId, theLength);
    }
    /** Return text position. */
    get position() {
        return this._myController != null ? this._myController.getTextLabelPosition(this._myObjId)
            : { x: 0.0, y: 0.0, z: 0.0 };
    }
    /** Set text position. */
    set position(thePos) {
        this._myController.setTextLabelPosition(this._myObjId, thePos);
    }
    /** Return text height. */
    get height() {
        return this._myController != null ? this._myController.getTextLabelHeight(this._myObjId) : 1.0;
    }
    /** Set text height. */
    set height(theHeight) {
        this._myController.setTextLabelHeight(this._myObjId, theHeight);
    }
}
